
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, Clock } from "lucide-react";

interface ArticleHeaderProps {
  title: string;
  image: string;
  publishedAt: string;
  readTime: string;
  category: string;
}

const ArticleHeader = ({ title, image, publishedAt, readTime, category }: ArticleHeaderProps) => {
  return (
    <div className="w-full h-[40vh] md:h-[60vh] relative">
      <div className="absolute inset-0 bg-black z-10"></div>
      <div className="absolute bottom-0 left-0 right-0 z-20 p-6 md:p-12">
        <div className="container-custom">
          <Link to="/blog" className="inline-flex items-center text-white hover:text-primary transition-colors mb-4">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Blog
          </Link>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-6">{title}</h1>
          <div className="flex flex-wrap items-center gap-6 text-white/90">
            <div className="flex items-center">
              <Calendar className="h-4 w-4 mr-2" />
              <time dateTime={publishedAt} className="text-sm">{publishedAt}</time>
            </div>
            <div className="flex items-center">
              <Clock className="h-4 w-4 mr-2" />
              <span className="text-sm">{readTime}</span>
            </div>
            <div className="px-3 py-1 bg-primary/20 text-primary rounded-full text-xs font-medium">
              {category}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleHeader;
